import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { setupSwiperPaginationWindow } from '../../src/js/includes/_1_swiper-pagination-window.js';

document.addEventListener('DOMContentLoaded', function() {
    IconsSlider();
});

function equalizeIconsSlideHeights(swiperEl) {
    if (!swiperEl) return;

    var slides = swiperEl.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    slides.forEach(function(slide) {
        slide.style.minHeight = '';
    });

    var maxHeight = 0;
    slides.forEach(function(slide) {
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });

    if (maxHeight <= 0) return;

    slides.forEach(function(slide) {
        slide.style.minHeight = maxHeight + 'px';
    });
}

function IconsSlider() {
    var swipers = document.querySelectorAll('.swiper.slider-icons');

    swipers.forEach(function(swiper) {

        var swiperSlider = new Swiper(swiper, {
            modules: [Pagination],
            loop: false,
            speed: 500,
            slidesPerView: 1.1,
            spaceBetween: 32,
            keyboard: {
                enabled: true,
            },
            pagination: {
                el: swiper.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                786: {

                    slidesPerView: 2,
                }
            }
        });

        // CSS should be enough for equal heights, but this keeps it stable
        // when slide content changes after initial layout (e.g. image load).
        setupSwiperPaginationWindow(swiperSlider, { visible: 5 });

        var scheduled = null;
        var scheduleEqualize = function() {
            if (scheduled) window.clearTimeout(scheduled);
            scheduled = window.setTimeout(function() {
                equalizeIconsSlideHeights(swiper);
            }, 50);
        };

        scheduleEqualize();
        window.addEventListener('load', scheduleEqualize, { once: true });
        window.addEventListener('resize', scheduleEqualize, { passive: true });
        swiperSlider.on('breakpoint', scheduleEqualize);
        swiperSlider.on('resize', scheduleEqualize);
    });
}